import {
  FsLivesRules,
  isFsDriverLivesRules,
  isFsRemainingLivesRules,
} from "db/model/match/Set/Knockout/FsLivesRules";
import { LivesRules } from "model/Match/Set/Knockout/LivesRules";

export const mapLivesRules = (
  fsModel: FsLivesRules
): LivesRules | undefined => {
  if (isFsDriverLivesRules(fsModel)) {
    if (!fsModel.tillLeft) {
      return undefined;
    }

    return {
      tillLeft: fsModel.tillLeft,
      livesLost: fsModel.livesLost ?? 1,
      numDrivers: fsModel.numDrivers ?? 1,
    };
  }

  if (isFsRemainingLivesRules(fsModel)) {
    if (fsModel.tillRemaining === undefined) {
      return undefined;
    }

    return {
      tillRemaining: fsModel.tillRemaining,
      livesLost: fsModel.livesLost ?? 1,
      numDrivers: fsModel.numDrivers ?? 1,
    };
  }

  if (!fsModel.startTrack) {
    return undefined;
  }

  return {
    startTrack: fsModel.startTrack,
    endTrack: fsModel.endTrack,
    livesLost: fsModel.livesLost ?? 1,
    numDrivers: fsModel.numDrivers ?? 1,
  };
};
